import { Period } from '#/shared/api/generated/analytics/models'

export const PERFORMANCE_RANGE_KEYS = {
  TODAY: 'today',
  SEVEN_DAYS: 'sevenDays',
  THIRTY_DAYS: 'thirtyDays',
  MTD: 'mtd',
  QTD: 'qtd',
  CUSTOM: 'custom',
} as const

export type PerformanceRangeKey =
  (typeof PERFORMANCE_RANGE_KEYS)[keyof typeof PERFORMANCE_RANGE_KEYS]

export const PERFORMANCE_RANGE_TO_PERIOD: Record<PerformanceRangeKey, Period> =
  {
    [PERFORMANCE_RANGE_KEYS.TODAY]: Period.today,
    [PERFORMANCE_RANGE_KEYS.SEVEN_DAYS]: Period['7d'],
    [PERFORMANCE_RANGE_KEYS.THIRTY_DAYS]: Period['30d'],
    [PERFORMANCE_RANGE_KEYS.MTD]: Period.mtd,
    [PERFORMANCE_RANGE_KEYS.QTD]: Period.qtd,
    [PERFORMANCE_RANGE_KEYS.CUSTOM]: Period.custom,
  }

export const PERFORMANCE_DELTA_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
  FLAT: 'flat',
} as const

export type PerformanceDeltaDirection =
  (typeof PERFORMANCE_DELTA_DIRECTIONS)[keyof typeof PERFORMANCE_DELTA_DIRECTIONS]

export function performanceDeltaDirection(
  value: number | null | undefined,
): PerformanceDeltaDirection {
  if (value == null || value === 0) return PERFORMANCE_DELTA_DIRECTIONS.FLAT
  return value > 0
    ? PERFORMANCE_DELTA_DIRECTIONS.UP
    : PERFORMANCE_DELTA_DIRECTIONS.DOWN
}

export const CHART_TYPE_KEYS = {
  BAR: 'bar',
  LINE: 'line',
} as const

export type ChartTypeKey =
  (typeof CHART_TYPE_KEYS)[keyof typeof CHART_TYPE_KEYS]

export const PERFORMANCE_SERIES_KEYS = {
  CHARGED: 'charged',
  DISPATCHED: 'dispatched',
} as const

export type PerformanceSeriesKey =
  (typeof PERFORMANCE_SERIES_KEYS)[keyof typeof PERFORMANCE_SERIES_KEYS]

export interface PerformanceChartPoint {
  date: string
  label: string
  charged: number
  dispatched: number
  isToday?: boolean
}

export const PERFORMANCE_STAT_KEYS = {
  HIGHEST_DAY: 'highestDay',
  LOWEST_DAY: 'lowestDay',
  DAILY_AVERAGE: 'dailyAverage',
} as const

export type PerformanceStatKey =
  (typeof PERFORMANCE_STAT_KEYS)[keyof typeof PERFORMANCE_STAT_KEYS]

export const STAT_VALUE_TONES = {
  SERIES: 'series',
  SUCCESS: 'success',
  WARNING: 'warning',
  NEUTRAL: 'neutral',
} as const

export type StatValueTone =
  (typeof STAT_VALUE_TONES)[keyof typeof STAT_VALUE_TONES]

export interface PerformanceStatRow {
  series: PerformanceSeriesKey
  value: string
  meta: string
  valueTone?: StatValueTone
}

export interface PerformanceStat {
  key: PerformanceStatKey
  rows: ReadonlyArray<PerformanceStatRow>
}
